export function withdrawalStatusLabel(t, status) {
  const key = `withdrawals.statusBadge.${status}`;
  const label = t(key);
  return label === key ? status : label;
}
